/**
 * Singapura AR Verification of Data — 폼값 → 템플릿 [[변수]] 최종 변환.
 *   · 반복부(directors/managing_directors/ceos/secretaries/auditors/shareholders/charges)를
 *     `${prefix}_${i}_${s}` 인덱스 키에서 item 배열([{k: value}])로 flatten.
 *   · 체크박스(revenue_exceeds_10m …)는 yes/no 문자열 그대로(백엔드 조건식이 truthy 비교).
 *   · 날짜는 "30 June 2026"(고객 원본 표기)으로 바꿔 넘긴다 — 반복부 item 포함(utils/longDate).
 */
import { longDateDeep } from './longDate';
import { V_LOOPS, V_CHARGES, V_SHARE_CAPITAL, type VLoop } from '../verification/verifyLoops';

function buildLoop(out: Record<string, any>, loop: VLoop): void {
  if (Array.isArray(out[loop.arrayKey])) return;
  const n = parseInt(String(out[loop.countKey] ?? '').trim(), 10);
  const max = Number.isFinite(n) && n > 0 ? n : 0;
  const rows: Array<Record<string, string>> = [];
  for (let i = 1; i <= max; i++) {
    const item: Record<string, string> = {};
    let any = false;
    for (const f of loop.fields) {
      const v = String(out[`${loop.prefix}_${i}_${f.s}`] ?? '').trim();
      if (v) { item[f.k] = v; any = true; }
      else item[f.k] = '';
    }
    if (any) rows.push(item);
  }
  if (rows.length) out[loop.arrayKey] = rows;
}

export function normalizeSingapuraVerificationForWord(input: Record<string, any>): Record<string, any> {
  const out: Record<string, any> = { ...input };
  for (const loop of V_LOOPS) buildLoop(out, loop);
  // "Nil" indebtedness 체크 → 담보 표를 4칸 모두 NIL 인 1행으로(입력한 담보 행은 무시)
  const nil = String(out.charges_nil ?? '').trim().toLowerCase();
  if (nil === 'yes' || nil === 'true' || nil === '1') {
    out.charges = [{ charge_date: 'NIL', charge_no: 'NIL', charge_amount: 'NIL', chargee_name: 'NIL' }];
  }
  buildLoop(out, V_CHARGES);
  buildLoop(out, V_SHARE_CAPITAL);
  return longDateDeep(out);
}
